import React from "react";
import {
  Card,
  CardBody,
  Typography,
  Button
} from "@material-tailwind/react";
import { ArrowLongRightIcon, ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export default function CiberIsgcontent() {



  return (
    <>

      <div className="w-full mx-auto inline-block md:w-3/4 md:flex-row ">
        <nav
    className="w-11/12 mx-auto mt-6 mb-2 text-sm text-gray-500 lg:w-full"
    aria-label="Breadcrumb"
  >
    <Link
      to="/Servicios-Ciberseguridad"
      className="hover:text-indigo-600 transition font-medium"
    >
      Ciberseguridad
    </Link>
    <span className="mx-2">›</span>
    <span className="text-gray-800">
      Cumplimiento — ISG
    </span>
  </nav>

  <div className="flex items-center gap-3 w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3">
                <ClipboardDocumentCheckIcon className="text-indigo-500 w-10 h-10 group-hover:text-white" />
        <Typography
           variant="h3"
           className="text-black font-sanz text-left"
         >
           
          Cumplimiento — ISG (Information Security Governance)
        </Typography>
          </div>

        <Typography
          className="w-11/12 mx-auto md:mt-0 text-left lg:w-full font-mono text-xl"
        >Ayudamos a tu organización a implementar y operar marcos de seguridad reconocidos internacionalmente, como ISO 27001, así como Sistemas de Gestión de Seguridad de la Información (SGSI). Evaluamos riesgos, definimos políticas, preparamos auditorías y alineamos tus procesos con las exigencias de la Ley Marco de Ciberseguridad 21.663 y la Ley 21.719 de Protección de Datos Personales.<br/>
        <br/>Nuestro trabajo transforma el cumplimiento en un habilitador estratégico, fortaleciendo la gobernanza, reduciendo riesgos y elevando la madurez de seguridad en toda la empresa.
        </Typography>
        <div className="flex flex-wrap justify-center gap-3 mt-10 md:justify-around">
         
         <Card className="mt-30 w-full">
                     <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
                       <CardBody>
                         {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                         <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                           SGSI – Implementación del Sistema de Gestión de Seguridad de la Información (ISO 27001)
                         </Typography>
                         <Typography className="group-hover:text-white">
                           Implementamos tu SGSI alineado a ISO/IEC 27001 para definir políticas, procesos y controles que fortalezcan la seguridad de la información y preparen a tu organización para certificarse.
                         <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
           <li className="flex items-start gap-2">
             <span>•</span> Diagnóstico preliminar de cumplimiento
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Análisis y tratamiento de riesgos de seguridad de la Información
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Diseño de políticas y procedimientos
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Documentación del SGSI y manual completo
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Desarrollo de Declaración de Aplicabilidad (SOA)
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Plan de concientización y capacitación
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Matriz de controles y métricas
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Reportes de Pentesting y vulnerabilidades
           </li>
         </ul>
                         </Typography>
                       </CardBody>
                       {/* <CardFooter className="pt-0">
                         <Link to="/Contact/#form" className="inline-block">
                           <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                             Conoce más sobre este servicio
                             <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                           </Button>
                         </Link>
                       </CardFooter> */}
                     </div>
                   </Card>
         
<Card className="mt-30 w-full">
                     <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
                       <CardBody>
                         {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                         <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                           Security Assessment
                         </Typography>
                         <Typography className="group-hover:text-white">
                           Evaluación completa del estado actual de tu seguridad de la información para identificar brechas, riesgos técnicos y controles deficientes en tu organización.
                         <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
           <li className="flex items-start gap-2">
             <span>•</span> Revisión de normativas y documentación
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Entrevistas con responsables de procesos
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Diagnóstico de controles de seguridad
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Gap Analysis con ISO 27001/27002, CIS, NIS2 y GDPR
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Pentesting y análisis de vulnerabilidades
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Roadmap priorizado y quick wins
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Re-test de vulnerabilidades
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Informe ejecutivo y técnico
           </li>
         </ul>
                         </Typography>
                       </CardBody>
                       {/* <CardFooter className="pt-0">
                         <Link to="/Contact/#form" className="inline-block">
                           <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                             Conoce más sobre este servicio
                             <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                           </Button>
                         </Link>
                       </CardFooter> */}
                     </div>
                   </Card>

<Card className="mt-30 w-full">
                     <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
                       <CardBody>
                         {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                         <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                           Gap Analysis ISO 27001 / 27002
                         </Typography>
                         <Typography className="group-hover:text-white">
                           Evaluamos el nivel de cumplimiento de tu organización frente a los requisitos de ISO 27001 y los controles de ISO 27002 para identificar brechas y definir acciones concretas de mejora.
                         <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
           <li className="flex items-start gap-2">
             <span>•</span> Evaluación de controles de seguridad de la información
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Revisión documental de políticas, procedimientos y evidencias actuales
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Identificación de brechas en relación con ISO 27001/27002
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Observaciones y recomendaciones de mejora
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Roadmap de acciones priorizadas
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Reportes de alerta temprana (si aplican)
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Informe de diagnóstico detallado + resumen ejecutivo
           </li>
         </ul>
                         </Typography>
                       </CardBody>
                       {/* <CardFooter className="pt-0">
                         <Link to="/Contact/#form" className="inline-block">
                           <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                             Conoce más sobre este servicio
                             <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                           </Button>
                         </Link>
                       </CardFooter> */}
                     </div>
                   </Card>

 <Card className="mt-30 w-full">
                     <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
                       <CardBody>
                         {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                         <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                           Análisis de Riesgos
                         </Typography>
                         <Typography className="group-hover:text-white">
                           Realizamos un análisis de riesgos basado en ISO/IEC 27005 para identificar amenazas, vulnerabilidades y su impacto en tus activos de información, definiendo un plan de tratamiento alineado a tus objetivos de negocio.
                         <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
           <li className="flex items-start gap-2">
             <span>•</span> Valoración de activos de información
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Identificación de amenazas y vulnerabilidades
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Evaluación de riesgos según probabilidad e impacto
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Matriz de riesgos y clasificación
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Plan de tratamiento de riesgos
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Declaración de Aplicabilidad (SOA) cuando corresponda
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Roadmap de acciones priorizadas
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Reportes de alerta temprana (si aplican)
           </li>
           <li className="flex items-start gap-2">
             <span>•</span> Informe completo con criterios, análisis y resultados
           </li>
         </ul>
                         </Typography>
                       </CardBody>
                       {/* <CardFooter className="pt-0">
                         <Link to="/Contact/#form" className="inline-block">
                           <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                             Conoce más sobre este servicio
                             <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                           </Button>
                         </Link>
                       </CardFooter> */}
                     </div>
                   </Card>

<div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
                <button>
<Link to="/Contact/#form" className="inline-block ">
                                    <Button onClick={() => { localStorage.setItem("ESP", "CIB"); localStorage.setItem("SER", "ISG") }} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                                        Solicitar este servicio
                                        <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                                    </Button>
                                </Link>
                                </button>
         
          </div>
         
        </div>
      </div>
    </>
  );
}